import { useState, useEffect, useCallback } from 'react';
import { Button } from '../components/ui/button';
import { Plus, Loader2, CalendarPlus } from 'lucide-react';
import api from '../lib/api';
import { useLanguage } from '../context/LanguageContext';
import { AppointmentDialog } from '../components/workshop/AppointmentDialog';
import { AppointmentCard, APPT_STATUS } from '../components/workshop/AppointmentCard';

const FILTERS = ['upcoming', 'scheduled', 'in_progress', 'completed', 'cancelled'];

export default function WorkshopAppointmentsPage() {
    const { language } = useLanguage();
    const el = language === 'el';
    const [items, setItems] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [filter, setFilter] = useState('upcoming');
    const [dialog, setDialog] = useState({ open: false, appointment: null });

    const load = useCallback(() => {
        api.get('/workshop/appointments').then((r) => setItems(r.data)).catch(() => setItems([]));
        api.get('/workshop/customers').then((r) => setCustomers(r.data)).catch(() => setCustomers([]));
    }, []);
    useEffect(() => { load(); }, [load]);

    const today = new Date().toLocaleDateString('sv-SE');
    const match = (a, f) => (f === 'upcoming' ? ['scheduled', 'in_progress'].includes(a.status) && a.date >= today : a.status === f);
    const shown = (items || []).filter((a) => match(a, filter));

    return (
        <div className="space-y-6" data-testid="workshop-appointments-page">
            <div className="flex flex-wrap items-center justify-between gap-3">
                <div>
                    <h1 className="text-2xl font-bold text-slate-800">{el ? 'Ραντεβού πελατών' : 'Customer appointments'}</h1>
                    <p className="text-zinc-500">{el ? 'Τα δικά σας ραντεβού, εκτός leasing' : 'Your own appointments, outside leasing'}</p>
                </div>
                <Button onClick={() => setDialog({ open: true, appointment: null })} className="bg-teal-700 hover:bg-teal-800 text-white rounded-sm" data-testid="add-appointment-btn"><Plus className="w-4 h-4 mr-2" />{el ? 'Νέο ραντεβού' : 'New appointment'}</Button>
            </div>
            <div className="flex flex-wrap gap-2" data-testid="appt-filters">
                {FILTERS.map((f) => (
                    <button key={f} onClick={() => setFilter(f)} className={`px-3 py-1.5 rounded-sm text-sm transition-colors ${filter === f ? 'bg-teal-700 text-white' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`} data-testid={`appt-filter-${f}`}>
                        {f === 'upcoming' ? (el ? 'Επερχόμενα' : 'Upcoming') : (el ? APPT_STATUS[f].el : APPT_STATUS[f].en)}{items ? ` (${items.filter((a) => match(a, f)).length})` : ''}
                    </button>
                ))}
            </div>
            {items === null ? <Loader2 className="w-6 h-6 animate-spin text-teal-700" /> : shown.length ? (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {shown.map((a) => <AppointmentCard key={a.id} a={a} el={el} onEdit={() => setDialog({ open: true, appointment: a })} onChanged={load} />)}
                </div>
            ) : (
                <div className="fleet-card p-10 text-center text-slate-400" data-testid="appt-empty"><CalendarPlus className="w-6 h-6 mx-auto mb-2" />{el ? 'Δεν υπάρχουν ραντεβού' : 'No appointments'}</div>
            )}
            <AppointmentDialog open={dialog.open} onOpenChange={(open) => setDialog({ ...dialog, open })} el={el} customers={customers} appointment={dialog.appointment} onSaved={load} />
        </div>
    );
}
